type RuntimeConfig = Partial<Record<string, string>>;

const runtimeConfig = (): RuntimeConfig =>
  ((window as Application).__CONFIG__ ?? {}) as RuntimeConfig;

const aliases: Record<string, string[]> = {
  VITE_API_BASE_URL: ['API_BASE_URL'],
  VITE_API_KEY: ['API_KEY'],
  VITE_CAMPAIGN_BASE_SLUG: ['CAMPAIGN_BASE_SLUG'],
  VITE_CAS_CLIENT_ID: ['CAS_CLIENT_ID'],
  VITE_CURRENT_TIME_MOCK_ENABLED: ['CURRENT_TIME_MOCK_ENABLED'],
  VITE_ENVIRONMENT: ['ENVIRONMENT'],
  VITE_RECAPTCHA_ENTERPRISE_KEY: [
    'RECAPTCHA_ENTERPRISE_KEY',
    'VITE_RECAPTCHA_ENTERPRICE_KEY'
  ],
  VITE_RECAPTCHA_ENTERPRICE_KEY: [
    'RECAPTCHA_ENTERPRISE_KEY',
    'VITE_RECAPTCHA_ENTERPRISE_KEY'
  ],
  VITE_SENTRY_DSN: ['SENTRY_DSN', 'VITE_SENTRY_DNS', 'VITE_APP_SENTRY_DSN'],
  VITE_SENTRY_DNS: ['SENTRY_DSN', 'VITE_SENTRY_DSN', 'VITE_APP_SENTRY_DSN'],
  VITE_SENTRY_LOG_CAPTURE_LEVELS: [
    'SENTRY_LOG_CAPTURE_LEVELS',
    'VITE_APP_SENTRY_LOG_CAPTURE_LEVELS'
  ],
  VITE_SENTRY_SAMPLE_RATE: ['SENTRY_SAMPLE_RATE'],
  VITE_USER_COUNTRY: ['USER_COUNTRY'],
  VITE_USER_LANGUAGE: ['USER_LANGUAGE'],
  VITE_APP_SENTRY_LOG_CAPTURE_LEVELS: ['VITE_SENTRY_LOG_CAPTURE_LEVELS']
};

export const getEnv = (key: string): string | undefined => {
  const keys = [key, ...(aliases[key] ?? [])];
  const config = runtimeConfig();

  for (const envKey of keys) {
    const value = config[envKey] ?? import.meta.env[envKey];

    if (value !== undefined && value !== '') return value;
  }

  return undefined;
};

export const requireEnv = (key: string): string => {
  const value = getEnv(key);

  if (!value) throw new Error(`Missing runtime config: ${key}`);

  return value;
};

export const getEnvironment = (): string =>
  getEnv('VITE_ENVIRONMENT') ?? import.meta.env.MODE;

export const isLocalDev = (): boolean => import.meta.env.DEV;

export const isRuntimeProduction = (): boolean =>
  getEnvironment() === 'production';

export const isRuntimeStaging = (): boolean =>
  getEnvironment() === 'staging' && !isLocalDev();
